import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import {
  getApiClient,
  initializeApiClient,
} from "../../../../Services/Api/ApiServices";

export const GetEV_ST_RouteManagerList = createAsyncThunk(
  "RouteManagerReducer/GetEV_ST_RouteManagerList",
  async (parameters, { rejectWithValue }) => {
    try {
      await initializeApiClient("application/json");
      const apiClient = getApiClient();
      const response = await apiClient.post(
        "api/DropDownsManager/GetEV_ST_RouteManagerList",
        parameters
      );

      const data = response.data.result; // Assuming response has a "data" field
      console.log(data, "appccccc");
      return data; // Return the extracted data
    } catch (error) {
      return rejectWithValue(error.message);
    }
  }
);

const RouteManagerReducer = createSlice({
  name: "RouteManagerReducer",
  initialState: {
    RouteManager: [],
    loadingRouteManager: false,
    errorRouteManager: null,
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(GetEV_ST_RouteManagerList.pending, (state, action) => {
        state.loadingRouteManager = true;
        state.RouteManager = action.payload;
        state.errorPageRenderByRole = null;
      })
      .addCase(GetEV_ST_RouteManagerList.fulfilled, (state, action) => {
        state.loadingRouteManager = false;
        state.RouteManager = action.payload;
      })
      .addCase(GetEV_ST_RouteManagerList.rejected, (state, action) => {
        state.loadingRouteManager = false;
        state.errorRouteManager = action.payload;
      });
  },
});

export default RouteManagerReducer.reducer;
